import React from 'react';
import {
  Pressable, Text, StyleSheet, View,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import PropTypes from 'prop-types';
import APMStyles from '../styles';

function GradientButton(props) {
  const {
    children, onPress, disabled, outline, style, icon,
  } = props;

  //   const disabledColor = [APMStyles.colors.disabled, APMStyles.colors.disabled];

  return (
    <Pressable
      disabled={disabled}
      onPress={onPress}
      style={style || styles.wrapper}
    >
      <LinearGradient
        colors={APMStyles.colors.gradient}
        start={[0, 0.5]}
        end={[1, 0.5]}
        style={styles.gradient}
      >
        {
          outline ? (
            <View style={styles.outlineContainer}>
              {icon && <MaterialCommunityIcons name={icon} size={24} color="white" style={styles.icon} />}
              <Text style={styles.text}>{children}</Text>
            </View>
          ) : (
            <View style={styles.container}>
              <Text style={styles.text}>{children}</Text>
            </View>
          )
        }
      </LinearGradient>
    </Pressable>
  );
}

GradientButton.defaultProps = {
  children: '',
  onPress: () => {},
  disabled: false,
  outline: false,
  style: {},
  icon: '',
};

GradientButton.propTypes = {
  children: PropTypes.any,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  icon: PropTypes.string,
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
  },
  gradient: {
    borderRadius: 10,
  },
  container: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  outlineContainer: {
    backgroundColor: APMStyles.colors.background,
    margin: 2,
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    paddingHorizontal: 4,
  },
  text: {
    color: APMStyles.colors.text,
    fontSize: APMStyles.typography.button,
    textAlign: 'center',
  },
});

export default GradientButton;
